import {
  RESET_MEDIA_PLAYER,
  GET_CONTACT_REQUESTED,
  GET_CONTACT_SUCCESS,
  GET_CONTACT_FAILURE,
  REFRESH_CONTACT_REQUESTED,
  REFRESH_CONTACT_SUCCESS,
  REFRESH_CONTACT_FAILURE,
  GET_STORAGEFILE_REQUESTED,
  GET_STORAGEFILE_SUCCESS,
  GET_STORAGEFILE_FAILURE,
  RESTORE_STORAGEFILES_REQUESTED,
  RESTORE_STORAGEFILES_SUCCESS,
  RESTORE_STORAGEFILES_FAILURE,
  GET_ROLE,
  SAVE_ROLE,
  UPDATE_MEDIA_PLAYER_CONTACT_REQUESTED,
  UPDATE_MEDIA_PLAYER_CONTACT_SUCCESS,
  UPDATE_MEDIA_PLAYER_CONTACT_FAILURE,
  UPDATE_REVIEW_GOAL_REQUESTED,
  UPDATE_REVIEW_GOAL_SUCCESS,
  UPDATE_REVIEW_GOAL_FAILURE,
  SAVE_ARCHIVE_AUDIT_SUCCESS,
  SAVE_ARCHIVE_AUDIT_FAILURE,
  SAVE_AUDIO_PLAYED_AUDIT_SUCCESS,
  SAVE_AUDIO_PLAYED_AUDIT_FAILURE,
  SAVE_TEXT_VIEWED_AUDIT_SUCCESS,
  SAVE_TEXT_VIEWED_AUDIT_FAILURE,
  UPDATE_CONTACT_AFTER_EVALUATION_SAVE,
  UPDATE_CONTACT_AFTER_EVALUATION_RESET,
  GET_TENANT_LICENSED_FEATURES_REQUESTED,
  GET_TENANT_LICENSED_FEATURES_SUCCESS,
  GET_TENANT_LICENSED_FEATURES_FAILURE,
} from './mediaPlayer.constants'
import api from './mediaPlayer.api'
import { createApiAction } from '../../../Helpers/actions'

export const updateContactAfterEvaluationSave = (payload, contactId) => ({
  payload,
  contactId,
  type: UPDATE_CONTACT_AFTER_EVALUATION_SAVE,
})

export const resetMediaPlayer = () => ({
  type: RESET_MEDIA_PLAYER,
})

export const updateContactAfterEvaluationReset = () => ({
  type: UPDATE_CONTACT_AFTER_EVALUATION_RESET,
})

export const getContactSuccess = contact => ({
  contact,
  type: GET_CONTACT_SUCCESS,
})

export const getContactError = error => ({
  error,
  type: GET_CONTACT_FAILURE,
})

export const getStorageFileRequested = () => ({
  type: GET_STORAGEFILE_REQUESTED,
})

export const getStorageFileSuccess = data => ({
  data,
  type: GET_STORAGEFILE_SUCCESS,
})

export const getStorageFileError = error => ({
  error,
  type: GET_STORAGEFILE_FAILURE,
})

export const restoreStorageFileRequested = () => ({
  type: RESTORE_STORAGEFILES_REQUESTED,
})

export const restoreStorageFilesSuccess = () => ({
  type: RESTORE_STORAGEFILES_SUCCESS,
})

export const restoreStorageFilesFailure = error => ({
  error,
  type: RESTORE_STORAGEFILES_FAILURE,
})

export const getContactRequested = contactId => ({
  contactId,
  type: GET_CONTACT_REQUESTED,
})

export const refreshContactRequested = () => ({
  type: REFRESH_CONTACT_REQUESTED,
})

export const refreshContactSuccess = contact => ({
  contact,
  type: REFRESH_CONTACT_SUCCESS,
})

export const refreshContactError = error => ({
  error,
  type: REFRESH_CONTACT_FAILURE,
})

const updateMediaPlayerContactRequested = contact => ({
  contact,
  type: UPDATE_MEDIA_PLAYER_CONTACT_REQUESTED,
})

const updateMediaPlayerContactSuccess = contact => ({
  contact,
  type: UPDATE_MEDIA_PLAYER_CONTACT_SUCCESS,
})

const updateMediaPlayerContactError = error => ({
  error,
  type: UPDATE_MEDIA_PLAYER_CONTACT_FAILURE,
})

const updateReviewGoalRequested = goalUpdate => ({
  goalUpdate,
  type: UPDATE_REVIEW_GOAL_REQUESTED,
})

const updateReviewGoalSuccess = () => ({
  type: UPDATE_REVIEW_GOAL_SUCCESS,
})

const updateReviewGoalFailure = error => ({
  error,
  type: UPDATE_REVIEW_GOAL_FAILURE,
})

const saveArchiveAuditSuccess = contactId => ({
  contactId,
  type: SAVE_ARCHIVE_AUDIT_SUCCESS,
})

const saveArchiveAuditFailure = error => ({
  error,
  type: SAVE_ARCHIVE_AUDIT_FAILURE,
})

const saveAudioPlayedAuditSuccess = contactId => ({
  contactId,
  type: SAVE_AUDIO_PLAYED_AUDIT_SUCCESS,
})

const saveAudioPlayedAuditFailure = error => ({
  error,
  type: SAVE_AUDIO_PLAYED_AUDIT_FAILURE,
})

const saveTextViewedAuditSuccess = contactId => ({
  contactId,
  type: SAVE_TEXT_VIEWED_AUDIT_SUCCESS,
})

const saveTextViewedAuditFailure = error => ({
  error,
  type: SAVE_TEXT_VIEWED_AUDIT_FAILURE,
})

export const getTenantLicensedFeaturesRequested = () => ({
  type: GET_TENANT_LICENSED_FEATURES_REQUESTED,
})

export const getTenantLicensedFeaturesSuccess = data => ({
  data,
  type: GET_TENANT_LICENSED_FEATURES_SUCCESS,
})

export const getTenantLicensedFeaturesError = error => ({
  error,
  type: GET_TENANT_LICENSED_FEATURES_FAILURE,
})

export const getContact = (contactId, { scopeType, goalId }) => {
  return async dispatch => {
    dispatch(getContactRequested(contactId))
    try {
      const contact = await api.getContact(contactId, { scopeType, goalId })
      dispatch(getContactSuccess(contact))
      return contact
    } catch (error) {
      dispatch(getContactError(error))
    }
  }
}

export const updateMediaPlayerContact = contact => {
  return async dispatch => {
    dispatch(updateMediaPlayerContactRequested(contact))
    try {
      await api.updateContact(contact)
      dispatch(updateMediaPlayerContactSuccess(contact))
    } catch (error) {
      dispatch(updateMediaPlayerContactError(error))
    }
  }
}

export const refreshContact = (contactId, { scopeType, goalId }) => {
  return async dispatch => {
    dispatch(refreshContactRequested())
    try {
      const contact = await api.getContact(contactId, { scopeType, goalId })
      dispatch(refreshContactSuccess(contact))
    } catch (error) {
      dispatch(refreshContactError(error))
    }
  }
}

export const getStorageFile = (contactId, isRootRecording = false) => {
  return async dispatch => {
    try {
      dispatch(getStorageFileRequested())
      const storageFile = await api.getStorageFile(contactId, isRootRecording)
      dispatch(getStorageFileSuccess(storageFile))
    } catch (error) {
      dispatch(getStorageFileError(error))
    }
  }
}

export const restoreStorageFiles = (contactId, mediaFormats) => {
  return async dispatch => {
    try {
      await api.restoreStorageFiles(contactId, mediaFormats)
      dispatch(restoreStorageFilesSuccess())
    } catch (error) {
      dispatch(restoreStorageFilesFailure(error))
    }
  }
}

export const updateReviewGoal = (contactId, goalId, payload) => {
  return async dispatch => {
    try {
      dispatch(updateReviewGoalRequested(payload))
      await api.updateReviewGoal(contactId, goalId, payload)
      dispatch(updateReviewGoalSuccess())
    } catch (error) {
      dispatch(updateReviewGoalFailure(error))
    }
  }
}

export const saveAudioPlayedAudit = (contactId, isRootRecording) => {
  return async dispatch => {
    try {
      await api.saveAudioPlayedAudit(contactId, isRootRecording)
      dispatch(saveAudioPlayedAuditSuccess(contactId))
    } catch (error) {
      dispatch(saveAudioPlayedAuditFailure(error))
    }
  }
}

export const saveTextViewedAudit = contactId => {
  return async dispatch => {
    try {
      await api.saveTextViewedAudit(contactId)
      dispatch(saveTextViewedAuditSuccess(contactId))
    } catch (error) {
      dispatch(saveTextViewedAuditFailure(error))
    }
  }
}

export const saveArchiveAudit = (contactId, isRootRecording, timezone) => {
  return async dispatch => {
    try {
      await api.saveArchiveAudit(contactId, isRootRecording, timezone)
      dispatch(saveArchiveAuditSuccess(contactId))
    } catch (error) {
      dispatch(saveArchiveAuditFailure(error))
    }
  }
}

export const setRoleLocally = role => ({
  type: GET_ROLE.SUCCESS,
  data: { role },
})

export const getTenantLicensedFeatures = () => {
  return async dispatch => {
    try {
      dispatch(getTenantLicensedFeaturesRequested())
      const licensedFeatures = await api.getTenantLicensedFeatures()
      dispatch(getTenantLicensedFeaturesSuccess(licensedFeatures))
    } catch (error) {
      dispatch(getTenantLicensedFeaturesError(error))
    }
  }
}

export const getRole = createApiAction(GET_ROLE, api.getRole)
export const saveRole = createApiAction(SAVE_ROLE, api.saveRole)
